import { useDelete_Block_List_Item_WorkspaceMutation } from '@geerd-nx/shareable-graphql';

export function useDeleteBlockListWorkspace() {
  const [mutate] = useDelete_Block_List_Item_WorkspaceMutation({
    update: (cache, { data }) => {
      const normalizedId = cache.identify({
        id: data?.delete_block_list_item_workspace?.returning[0].id,
        __typename: 'block_list_item_workspace',
      });
      cache.evict({ id: normalizedId });
      cache.gc();
    },
  });
  return mutate;
}
